import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { api, type StockOverviewParams } from '@/lib/api-client'

export function useStockOverview(params?: StockOverviewParams) {
  return useQuery({
    queryKey: ['stock-overview', params],
    queryFn: () => api.stock.overview(params),
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  })
}

export function useSkuTrend(id: number | null, months = 6) {
  return useQuery({
    queryKey: ['stock-sku-trend', id, months],
    queryFn: () => api.stock.skuTrend(id!, months),
    enabled: id != null,
    staleTime: 60_000,
  })
}
